import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../controls/button/button.component';

export type ConfirmationPopupStyle = 'ok' | 'yesno' | 'yesnocancel';

export interface ConfirmationPopupConfig {
  title?: string;
  text?: string;
  style?: ConfirmationPopupStyle;
  yesCaption?: string;
  noCaption?: string;
  yes?: () => void;
  no?: () => void;
  cancel?: () => void;
}

/**
 * component for Confirm Action
 */
@Component({
  template: `
    <div class="modal-header">
      <h5 class="m-0">{{ title | translate }}</h5>
    </div>
    <div class="modal-body">
      @if (config.text) {
        <div [innerHTML]="config.text | translate"></div>
      }
    </div>
    <div class="modal-footer">
      @if (style === 'ok') {
        <app-button (click)="handleOk()">
          OK
        </app-button>
      }

      @if (style === 'yesno' || style === 'yesnocancel') {
        <app-button (click)="handleYes()">
          {{ yesCaption | translate }}
        </app-button>

        <app-button variant="danger" (click)="handleNo()">
          {{ noCaption | translate }}
        </app-button>
      }

      @if (style === 'yesnocancel') {
        <app-button variant="warning" [outline]="true" (click)="handleCancel()">
          {{ 'Cancel' | translate }}
        </app-button>
      }
    </div>
  `,
  standalone: true,
  imports: [TranslateModule, ButtonComponent],
})
export class ConfirmationPopupComponent implements OnInit {

  config: ConfirmationPopupConfig = {
    title: 'Confirm Action',
    style: 'yesno',
  };
  title: string = 'Confirm Action';
  style: ConfirmationPopupStyle = 'yesno';
  yesCaption: string = 'Yes';
  noCaption: string = 'No';

  constructor(private modal: BsModalRef) {
  }

  ngOnInit() {
    this.title = this.config.title || 'Confirm Action';
    this.style = this.config.style || 'yesno';
    this.yesCaption = this.config.yesCaption || 'Yes';
    this.noCaption = this.config.noCaption || 'No';
  }

  handleOk() {
    this.modal.hide();
  }

  handleYes() {
    this.modal.hide();
    this.config.yes?.();
  }

  handleNo() {
    this.modal.hide();
    this.config.no?.();
  }

  handleCancel() {
    this.modal.hide();
    this.config.cancel?.();
  }
}
